import React, { useCallback, useReducer } from "react";

import Traductor from "../../Traductor";
import ManagementFiltersModal from ".//ManagementFiltersModal";
import ManagementFiltersTags from "./ManagementFiltersTags";

const initialFiltersState = {
  modalVisible: false,
};

const filtersReducer = (state, { type }) => {
  switch (type) {
    case "SHOW":
      return { ...state, modalVisible: true };
    case "HIDE":
      return { ...state, modalVisible: false };
    default:
      return state;
  }
};

const ManagementFilters = ({ filters, onChange }) => {
  const t = new Traductor();
  const [{ modalVisible }, dispatch] = useReducer(
    filtersReducer,
    initialFiltersState
  );

  const onChangeFilters = useCallback(
    (payload) => {
      dispatch({ type: "HIDE" });
      onChange(payload);
    },
    [onChange]
  );

  return (
    <>
      <div className="o-inline-group u-m-none u-flex u-mb">
        <div className="sg-component-variant">
          <button
            className="c-btn  c-btn--icon u-mr-large"
            onClick={() => dispatch({ type: "SHOW" })}
          >
            <i className="c-btn__icon c-icon  c-icon--[control-filter-02] c-icon--xsmall" />
            <span className="c-btn__text u-pr-xsmall">
              {t.getTraduction("Filters")}
            </span>
          </button>
        </div>
        <ManagementFiltersTags
          filters={filters}
          onDeleteTag={onChangeFilters}
        />
      </div>
      {modalVisible && (
        <ManagementFiltersModal
          onChangeFilters={onChangeFilters}
          onClose={() => dispatch({ type: "HIDE" })}
          filters={filters}
        />
      )}
    </>
  );
};

export default ManagementFilters;
